<template>
    <div class="work">
        <h3>This Week's Time Behind Each Technology</h3>
        <div>
            <div class="coin-container" v-for="(work, index) in workThis" :key="index"
                 ontouchstart="this.classList.toggle('hover');">
                <figure class="chart" :data-percent="calculatePercentage(work.percent)">
                    <div class="front">
                        <figcaption></figcaption>
                        <img class="node" v-if="getSrcOrNull(work.name) !== work.name" :src="getSrcOrNull(work.name)">
                        <span v-if="getSrcOrNull(work.name) === work.name" class="node node-span">{{work.name}}</span>
                        <svg width="200" height="200">
                            <circle class="outer" :style="{'stroke-dashoffset': calcDashOffset(work.percent)}" cx="95"
                                    cy="95"
                                    r="85" transform="rotate(-90, 95, 95)"/>
                        </svg>
                    </div>
                    <div class="back">
                        <div class="coin-back-content">

<!--                            <span>{{work.name}}</span><br>-->
                            <span v-text="getTotalHoursInDev(work.percent, work.name)"></span>

                        </div>
                    </div>
                </figure>
            </div>
        </div>
    </div>
</template>
<script>
    import jsonp from 'jsonp';

    // let url = 'https://wakatime.com/share/@b72ba8cd-6de5-40e6-bead-a9fe96627675/67fe53f4-f933-4c61-bc1c-2b8c3fae24ec.json';
    let url = 'api/share/@b72ba8cd-6de5-40e6-bead-a9fe96627675/67fe53f4-f933-4c61-bc1c-2b8c3fae24ec.json';


    export default {
        name: 'waka-dev',
        beforeMount() {
            let wakaTimesAPICall = new Promise((resolve, reject) => {
                jsonp(url, null, function (err, response) {
                    if (err) {
                        reject(err.message);
                    } else {
                        resolve(response.data);

                    }
                });
            }).then((message) => {
                // get width of screen
                if (window.screen.width >= 1024) {
                    this.workThis = message.splice(0, 6);
                } else {
                    this.workThis = message.splice(0, 4);
                }
            }).catch((message) => {
                console.log(message);
            });
        },
        methods: {
            getTotalHoursInDev: function (percent, name) {
                let minutes = Math.floor((.01 * percent) * this.minutes());
                let hours = Math.floor(minutes / 60);
                let minuteMod = minutes % 60;
                if (name.toLowerCase() === 'text') {
                    return hours + 'h ' + minuteMod + 'm taking notes.'
                } else if (name.toLowerCase() === 'html') {
                    return hours + 'h ' + minuteMod + 'm writing Adobe\'s HTL.'
                }
                return hours + 'h ' + minuteMod + 'm writing ' + name + '.';
            },
            getDay: function (dateValue) {
                var timeString = dateValue.grand_total.hours + ' hours and ' + dateValue.grand_total.minutes + ' minutes.';
                var dayString = dateValue.range.text;
                var activityDay = dayString.split(' ')[0];
                return activityDay + ' - ' + timeString;
            },
            calculatePercentage: function (percent) {
                return ((Math.round((Math.floor(percent) * .1) * 4)) / 4) * 10;
            },
            calcDashOffset(percent) {
                let zero = 534;
                let incrementOfOne = zero / 100;
                return zero - (Math.floor(percent) * incrementOfOne);
            },
            getSrcOrNull(name) {
                let assetPaths = {
                    'JavaScript': this.publicPath + 'logos/JavaScript_logo.svg',
                    'Java': this.publicPath + 'logos/Java_logo.svg',
                    'Vue.js': this.publicPath + 'logos/Vue_Logo.svg',
                    'SCSS': this.publicPath + 'logos/Sass_Logo.svg',
                    'HTML': this.publicPath + 'logos/HTML5_logo.svg',
                    'JSON': this.publicPath + 'logos/JSON_logo.svg',
                    'LESS': this.publicPath + 'logos/LESS_Logo.svg'
                };
                if (assetPaths[name]) {
                    return assetPaths[name];
                } else {
                    return name;
                }
            }
        },
        data: function () {
            let randomTotal = (2400 + (10 * Math.floor( Math.random() * 100 )));
            function calc100() {
                // return 6 numbers that add up to 100%
                let goofSum=0;
                let goofyArray = [];
                let total = 100;
                for (let i = 0; i < 6; i++) {
                    let firstRandom = i + (Math.floor(Math.random() * (total - goofSum)));
                    if (i === 0 && firstRandom > 59) {
                        firstRandom = firstRandom - (Math.floor(Math.random() * firstRandom));
                    }
                    goofyArray.push(firstRandom);
                    goofSum += firstRandom;
                }
                return goofyArray;
            }

            let percentArray = calc100();

            return {
                publicPath: process.env.BASE_URL,
                workThis: [
                    {name:"JavaScript",percent: percentArray[0]},
                    {name:"Java",percent: percentArray[1]},
                    {name: "Vue.js", percent: percentArray[2]},
                    {name:"HTML",percent: percentArray[3]},
                    {name: "SCSS", percent: percentArray[4]},
                    {name: "LESS", percent: percentArray[5]},
                ],
                minutes: function () {
                    let totalTime = sessionStorage.getItem('totalMinutes');
                    return totalTime || randomTotal;
                }
            };
        }
    }
</script>
